import React from 'react';
import clicksound from './music/click.mp3';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const NextLevelModal = ({ show, levels, onPlayNextLevel }) => {
    const { t } = useTranslation();
    if (!show) return null;

    // Function to play sound
    const playClickSound = () => {
        const audio = new Audio(clicksound);
        audio.play();
    };

    return (
      <div className="modal-overlay-game flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
        <div className="modal-content-game bg-gambar lg:py-32 sm:py-16 text-center relative flex flex-col items-center lg:w-[25rem;] sm:w-[15rem]">
          <h2 className="winner-title-game lg:text-4xl sm:text-lg font-bold lg:mb-4 sm:mb-2">
            {t("congratulation")}
          </h2>
          <div className="my-4 text-center">
            <p className="winner-name-game lg:text-2xl sm:text-sm font-bold rounded-full lg:p-5 lg:mb-4 sm:p-2 sm:mb-2">
              Level {levels}
            </p>
          </div>
          <div className="modal-footer-game lg:mb-5">
            <button
              className="new-game-button block text-white font-bold py-2 px-4 rounded-full bg-blue-500 hover:bg-blue-600 shadow-lg transition-all duration-200 ease-in-out lg:text-xl sm:text-xs sm:px-2 md:text-xs"
              onClick={() => {
                playClickSound(); // Play the sound
                onPlayNextLevel(); // Execute the passed function
              }}
            >
              {t("continue")}
            </button>
          </div>
        </div>
      </div>
    );
};

export default NextLevelModal;
